import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { get360Data, goToTop, getLoading, setTabsNextAndPrevButtons, setCursorWaiting, hideCmsHiddenBlock } from '../../../utils';

import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import SummaryCalculator from '../../../Helpers/summarycalculator';
import GTMHelper from '../../../Helpers/gtmHelper';
import NavHelper from '../../../Helpers/navhelper';

import Button from '../../1_Atoms/Button/Button';
import { Svg } from '../../1_Atoms/Svg/Svg';
import CollapseLegal from '../../2_Molecules/Collapse/CollapseLegal';
import ColourCard from '../../2_Molecules/ColourCard/ColourCard';
import ThreeSixtyContainer from '../../3_Organisms/360Container/360Container';
import { Nav } from '../../3_Organisms/Nav/Nav';
import { PreOrderModal } from '../../3_Organisms/Modal/PreOrderModal';
import { Pricing } from '../../3_Organisms/Pricing/Pricing';
import { Modal } from '../../3_Organisms/Modal/Modal';
import { Alert } from '../../3_Organisms/Alert/Alert';

export const Colours = ({ ...props }) => {
    const [loading, setLoading] = useState(true);
    const [is360Loading, setIs360Loading] = useState(true);
    const summaryCalculator = window.summaryCalculator;
    let defaultInteriorColour = JSON.parse(sessionStorage.getItem(Constants.DefaultInteriorColour));
    let defaultExteriorColour = JSON.parse(sessionStorage.getItem(Constants.DefaultExteriorColour));
    const { year, carline, trim, model, packageCode } = useParams();
    const [nav, setNav] = React.useState(null);
    let extArray = null;
    const [images, setImages] = React.useState({});
    const navigate = useNavigate();
    const listRef = React.useRef();
    const legalContent = JSON.parse(sessionStorage.getItem(Constants.LegalColours));
    const [legalModalOpen, setLegalModalOpen] = React.useState(false);
    const { t, i18n } = useTranslation(['colours', 'general']);
    const [selectedColourInteriorIndex, setSelectedColourInteriorIndex] = React.useState(null);
    const [selectedColourExteriorIndex, setSelectedColourExteriorIndex] = React.useState(null);
    const [showFinancePrice, setShowFinancePrice] = React.useState(summaryCalculator.ShowFinancePrice);

    const [preorderOpen, setPreorderModalOpen] = React.useState(false);
    
	const gtmHelper = new GTMHelper();
	const navHelper = new NavHelper();

    hideCmsHiddenBlock();

    summaryCalculator.CurrentStep = 3;

    React.useEffect(() => {
        const toRender = navHelper.getNavContent(t);
        setNav(toRender);
        
        async function executeTasks() {
            if (window.bnp_under_maintenance)
                return;

            if (!summaryCalculator.isDataLoaded()) {
                await summaryCalculator.loadTrims(year, carline);

                const trimIndex = summaryCalculator.AvailableTrim.trims.findIndex(obj => obj.trim_type.url_slug === trim);
                await summaryCalculator.setSelectedTrimIndex(trimIndex);

                setLoading(false);

                setNav(null);
            } else {
                setLoading(false);
            }

            if (!loading) {
                /*if (nav === null) {
                    setNav(navHelper.getNavContent(year, carline, trim, model, packageCode, summaryCalculator.CurrentStep, t));
                }*/

                summaryCalculator.SetSelectedColorsFromParams();

                if (summaryCalculator.SelectedColourInterior === null) {
                    if (summaryCalculator.SelectedColourInteriorIndex !== null)
                        summaryCalculator.SelectedColourInteriorIndex = summaryCalculator.SelectedColourInteriorIndex; // Added this for when the page is beeing ctrl-r
                    else {
                        defaultInteriorColour = summaryCalculator.Colours.visual.interiors[0];
                        summaryCalculator.Colours.visual.interiors.map((Colour, index) => {
                            if (defaultInteriorColour.id === Colour.id)
                                summaryCalculator.SelectedColourInteriorIndex = index;
                                setSelectedColourInteriorIndex(index);
                        })
                    }
                }

                if (summaryCalculator.SelectedColourExterior === null) {
                    if (summaryCalculator.SelectedColourExteriorIndex !== null)
                        summaryCalculator.SelectedColourExteriorIndex = summaryCalculator.SelectedColourExteriorIndex; // Added this for when the page is beeing ctrl-r
                    else {
                        defaultExteriorColour = defaultInteriorColour.default_exterior;
                        Object.entries(summaryCalculator.Colours.visual.exteriors).map((Colour, index) => {
                            if (defaultExteriorColour.id === Colour[1]['id'])
                                summaryCalculator.SelectedColourExteriorIndex = index;
                                setSelectedColourExteriorIndex(index);
                        })
                    }
                }

                if (summaryCalculator.SelectedColourExteriorIndex > -1 && summaryCalculator.Colours) {
                    const extArray = Object.entries(summaryCalculator.Colours.visual.exteriors);
                    setImages(get360Data(summaryCalculator.Colours.visual, extArray[summaryCalculator.SelectedColourExteriorIndex][1], summaryCalculator.Colours.visual.interiors[summaryCalculator.SelectedColourInteriorIndex]));
                    setIs360Loading(false);
                } else if (summaryCalculator.AvailableTrim) {
                    setImages(get360Data(summaryCalculator.AvailableTrim.trims[summaryCalculator.SelectedTrimIndex].visual));
                    setIs360Loading(false);
                }
            
                showWarning();    
            }
        }

		if (listRef.current) {
			setListMaxHeight();
        }
  
        executeTasks();
    }, [summaryCalculator, selectedColourExteriorIndex, selectedColourInteriorIndex, loading, is360Loading]);

    React.useEffect(() => {
        //console.log('360 loading');
    }, [is360Loading]);
    
    function getAllowedExteriorsIds(exteriors) {
        let allowedExteriors = [];
        exteriors.forEach(exterior => {
            allowedExteriors.push(exterior.id);
        });
        return allowedExteriors;
    }

    async function handleSelectedColourInterior(index) {
        await summaryCalculator.setSelectedColourInteriorIndex(index);
        setSelectedColourInteriorIndex(index);
		gtmHelper.setGTM({'action':'Interior Colour Change'}, false, false);

        const allowedExteriors = getAllowedExteriorsIds(summaryCalculator.Colours.visual.interiors[index].allowed_exteriors);
        summaryCalculator.AllowedColoursExterior = allowedExteriors
        if (!allowedExteriors.includes(Object.entries(summaryCalculator.Colours.visual.exteriors)[summaryCalculator.SelectedColourExteriorIndex][1].id)) {
            const defaultExteriorId = summaryCalculator.Colours.visual.interiors[index].default_exterior.id;
            Object.entries(summaryCalculator.Colours.visual.exteriors).forEach(async (exterior, index) => {
                if (exterior[1].id === defaultExteriorId) {
                    await summaryCalculator.setSelectedColourExteriorIndex(index);
                    setSelectedColourExteriorIndex(index);
                }
            })
        }
    }

    async function handleSelectedColourExterior(index) {
        setCursorWaiting(true);

        setLoading(true);

        await summaryCalculator.setSelectedColourExteriorIndex(index);
        setSelectedColourExteriorIndex(index);
		gtmHelper.setGTM({'action':'Exterior Colour Change'}, false, false);

        const images = get360Data(summaryCalculator.Colours.visual, extArray[index][1], summaryCalculator.Colours.visual.interiors[summaryCalculator.SelectedColourInteriorIndex]);
        setImages(images);
        setCursorWaiting(false);
    }

    function nextStep() {
        goToTop();
        navigate(`/${year}/${carline}/${trim}/${model}/${packageCode}/wheels${decodeURI(window.location.search)}`)
		gtmHelper.setGTM({'action':'Next Step'}, true , false);
    }

    function showWarning() {
        let showWarningMessage = false;
        Object.entries(summaryCalculator.Colours.visual.exteriors).map((Colour, index) => {
            if (!summaryCalculator.AllowedColoursExterior.includes(Colour[1].id)) {
                showWarningMessage = true;
            }
        });
		showWarningMessage = true;
        return showWarningMessage;

    }

    function setListMaxHeight() {
        if (listRef.current){
            if (window.innerWidth < 1025) {
                listRef.current.style.maxHeight = 'unset';
                listRef.current.style.overflow = 'auto';
            } else {
                const incentivebar = document.querySelector('.mz-alert__item'); // Red alert bar

                listRef.current.style.height = `${window.innerHeight - (document.querySelector(".mz-sticky-submenu")?.offsetTop + document.querySelector(".mz-sticky-submenu")?.offsetHeight + document.querySelector(".mz-pricing")?.offsetHeight + (incentivebar ? incentivebar.offsetHeight : 0) + 50)}px`;
                listRef.current.style.overflow = 'auto';
            }
		}

	}

    function handleShowFinanceClick(value) {
        setShowFinancePrice(value);
    }

    if (summaryCalculator.Colours && summaryCalculator.Colours.visual) {
        extArray = Object.entries(summaryCalculator.Colours.visual.exteriors);
    }

    if (summaryCalculator.SelectedColourInterior !== null && summaryCalculator.Colours && summaryCalculator.AllowedColoursExterior.length === 0) {
        const allowedExteriors = getAllowedExteriorsIds(summaryCalculator.Colours.visual.interiors[summaryCalculator.SelectedColourInteriorIndex].allowed_exteriors);
        summaryCalculator.AllowedColoursExterior = allowedExteriors;
    }

	window.addEventListener('resize', setListMaxHeight);

    return (
        <>
        {getLoading(loading, t)}
        <div className="mz-colours-page mz-top-nav-spacing grid-no-gutter-sm">
            <Nav nav={nav} />
            <Alert />

            {summaryCalculator.Colours?.visual ?
                <div key='0' className="mz-full-width mz-colours-page__content general-content">
                    <div className="mz-colours-page__content-left">
                        {images.imagePathInterior ?
                            <ThreeSixtyContainer imagePathInterior={images.imagePathInterior} imagePath={images.imagePath} imageAmount={images.imageAmount} imageName={images.imageName} trimName={summaryCalculator.VehicleTitle} imageIsLoading={is360Loading}  /> : <></>}
                    </div>
                    <div className="mz-colours-page__content-right right-container">

                        <div className="mz-colours-page__package-card-list right-container" ref={listRef}>
							<h5 className='mz-colours-page__package-card-list-title'>{t("select_exterior_colour")}</h5>
                            {showWarning() ? <div className="mz-alert-message paragraph paragraph--tight">
                                <i className="mz-svg mz-svg-warning mz-svg--red"></i>
                                <span className="mz-alert-message__text">{t("general:warning_change_color_selection")}</span>
                            </div> : null}
                            <div className='mz-colours-page__package-card-list-container'>
                                {Object.entries(summaryCalculator.Colours.visual.exteriors).map((Colour, index) => <ColourCard Colour={Colour[1]} Selected={summaryCalculator.SelectedColourExteriorIndex === index} HandleSelectedColour={handleSelectedColourExterior}
								isExterior={true} Index={index} key={index} Disabled={!summaryCalculator.AllowedColoursExterior.includes(Colour[1].id)} showFinancePrice={showFinancePrice}></ColourCard>)}
                            </div>
                            <hr className='mz-colours-page__package-card-list-separator' />
							<h5 className='mz-colours-page__package-card-list-title'>{t("select_interior_colour")}</h5>
                            <div className='mz-colours-page__package-card-list-container'>
                                {summaryCalculator.Colours.visual.interiors.map((Colour, index) => <ColourCard Colour={Colour} Selected={summaryCalculator.SelectedColourInteriorIndex === index}
								isExterior={false} HandleSelectedColour={handleSelectedColourInterior} Index={index} key={index} showFinancePrice={showFinancePrice}></ColourCard>)}
                            </div>

                            <div className="mz-legal mz-mobile">
                                <Button
                                    className="mz-btn mz-btn--legal text--grey"
                                    label={t("general:legal")}
                                    backgroundColor="grey"
                                    colour="grey"
                                    icon={true}
                                    iconAfter={true}
                                    svg_className=""
                                    svg_list="plus"
                                    size={0.6}
                                    onClick={() => {
										document.querySelector('body').classList.add('disabled');
										setLegalModalOpen(true)
									}}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                : null}
            {summaryCalculator.Colours?.visual ?
                <Pricing builtLabel={t("general:price_as_built")} builtPrice="$" loanLabel={t("general:loan_label")} loanPrice="$" saveLabel={t("general:save_build")}
                    leaseLabel={t("general:show_lease_price")} financeLabel={t("general:show_finance_price")} buttonLabel={t("general:next_wheel")} summaryCalculator={summaryCalculator}
                    HandleNextClick={nextStep} setLegalModalOpen={setLegalModalOpen} HandleShowFinanceClick={handleShowFinanceClick} setPreorderModalOpen={setPreorderModalOpen} /> : null}
            <Modal modalContent={legalContent} isOpen={legalModalOpen} handleClose={setLegalModalOpen} modalId='legalModal' />
            <PreOrderModal isOpen={preorderOpen} handleClose={setPreorderModalOpen}></PreOrderModal> 
        </div>
        </>
    )
}

export default Colours;